import { render, staticRenderFns } from "./OpportunitySection.vue?vue&type=template&id=bcf58c4c&scoped=true"
import script from "./OpportunitySection.vue?vue&type=script&lang=js"
export * from "./OpportunitySection.vue?vue&type=script&lang=js"
import style0 from "./OpportunitySection.vue?vue&type=style&index=0&id=bcf58c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf58c4c",
  null
  
)

export default component.exports